module.exports = __webpack_public_path__ + "img/lionparcel-ocbc-illustration.3e45e15b.svg";